<template>
	<default-popup>
		<div class="content">
			<h2 class="popup-title">{{ titles[currentStep] }}</h2>
			<p v-if="currentStep === 0">{{ $t('forms.setup_pin_disclaimer') }}</p>
			<pin-field name="first_pin" v-if="currentStep === 0" :loading="loading"/>
			<pin-field name="second_pin" v-if="currentStep === 1" :loading="loading"/>
			<div class="actions">
				<button class="button style-1" @click.prevent="$store.dispatch('closePopups')">
					<span class="inner">{{ $t('forms.setup_later') }}</span>
				</button>
			</div>
		</div>
	</default-popup>
</template>

<script>
	import {Device} from '@capacitor/device';
	import {Storage} from '@capacitor/storage';
	import DefaultPopup from "./DefaultPopup";
	import PinField from "../form-fields/PinField";
	import { trackEvent } from '@/analytics';

	export default {
		name: "SetupPinPopup",
		components: {
			DefaultPopup,
			PinField,
		},
		data() {
			return {
				loading: false,
				firstPin: null,
				secondPin: null,
				currentStep: 0,
				titles: [
					this.$t('forms.setup_pin'),
					this.$t('forms.repeat_pin')
				],
			}
		},
		methods: {
			setPin(data) {
				if (data.name === 'first_pin') {
					this.firstPin = data.value;
					this.currentStep++;
					return true;
				}
				if (data.name === 'second_pin') {
					this.secondPin = data.value;
					if (this.firstPin !== this.secondPin) {
						this.currentStep--;
						this.firstPin = null;
						this.secondPin = null;
						return false;
					}
				}

				this.savePin();
			},
			async savePin() {
				this.loading = true;
				trackEvent('form_submit', { form_name: 'setup_pin', module: 'auth' });
				const deviceId = await Device.getId();
				this.axios.post('/api/user/store-native-auth', {
					device_id: deviceId.identifier,
					type: 'pin',
					pin: this.firstPin,
				}).then(async response => {
					this._submitSuccess = true;
					trackEvent('form_submit_success', { form_name: 'setup_pin', module: 'auth' });
					await Storage.set({
						key: 'user_pin',
						value: deviceId.identifier,
					});
					this.$root.$emit('pin-login-setup');
					this.$store.dispatch('closePopups');
					this.loading = false;
				}).catch(error => {
					trackEvent('form_submit_error', {
						form_name: 'setup_pin',
						module: 'auth',
						error_message: error && error.response && error.response.data ? error.response.data.message : (error && error.message),
						error_status: error && error.response ? String(error.response.status) : null,
					});
					this.loading = false;
				})
			},
		},
		mounted() {
			this._submitSuccess = false;
			trackEvent('form_open', { form_name: 'setup_pin', module: 'auth' });
			this.$root.$on('pin-value-changed', (data) => {
				this.setPin(data);
			});
		},
		beforeDestroy() {
			if (!this._submitSuccess) {
				trackEvent('form_close', { form_name: 'setup_pin', module: 'auth' });
			}
		},
		destroyed() {
			this.$root.$off('pin-value-changed');
		}
  }
</script>

<style scoped lang="scss">
	.default-popup {
		.popup-title {
			font-size: 26px;
			margin-bottom: 25px;
			min-height: 62px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	.content {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.actions {
		margin-top: auto;
	}

	.pin-field {
		margin-bottom: 20px;
	}
</style>